import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const styles = tv({
    slots: {
        root: `
      iris:group
      iris:inline-flex
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:gap-(--comp-space-gap-icon-button-label)
      iris:rounded-(--comp-size-radius-icon-button)
      iris:font-(family-name:--comp-type-font-icon-button)
      iris:duration-(--comp-motion-duration-icon-button)
      iris:ease-(--comp-motion-easing-icon-button)
    `,
        icon: `
      iris:box-content
      iris:flex
      iris:items-center
      iris:justify-center
      iris:rounded-(--base-size-radius-rounded)
      iris:transition-all
      iris:duration-(--comp-motion-duration-icon-button)
      iris:ease-(--comp-motion-easing-icon-button)
    `,
        label: `
      iris:cursor-pointer
      iris:text-(length:--comp-type-size-icon-button-label)
      iris:leading-(--comp-type-leading-icon-button-label)
      iris:font-(--comp-type-weight-icon-button-label)
      iris:group-hover:underline
    `,
    },
    variants: {
        orientation: {
            vertical: {
                root: "iris:flex-col",
            },
            horizontal: {
                root: "iris:flex-row",
            },
        },
        size: {
            sm: {
                icon: `
          iris:size-(--comp-size-icon-icon-button-sm)
          iris:p-(--comp-space-padding-icon-button-sm)
        `,
            },
            md: {
                icon: `
          iris:size-(--comp-size-icon-icon-button-md)
          iris:p-(--comp-space-padding-icon-button-md)
        `,
            },
        },
        inverse: {
            true: {
                root: focusStyles.inverse,
                icon: `
          iris:bg-(--comp-color-background-icon-button-inverse-rest)
          iris:text-(--comp-color-content-icon-button-icon-inverse)
          iris:group-hover:bg-(--comp-color-background-icon-button-inverse-hover)
          iris:group-active:bg-(--comp-color-background-icon-button-inverse-pressed)
        `,
                label: "iris:text-(--comp-color-content-icon-button-label-inverse)",
            },
            false: {
                root: focusStyles.default,
                icon: `
          iris:bg-(--comp-color-background-icon-button-rest)
          iris:text-(--comp-color-content-icon-button-icon)
          iris:group-hover:bg-(--comp-color-background-icon-button-hover)
          iris:group-active:bg-(--comp-color-background-icon-button-pressed)
        `,
                label: "iris:text-(--comp-color-content-icon-button-label)",
            },
        },
    },
    defaultVariants: {
        orientation: "vertical",
        size: "sm",
        showLabel: true,
        inverse: false,
    },
});

export { styles as default };
